// icons
import { MdQueryStats, MdBarChart, MdPeople, MdWarning, MdAccessibility, MdTimeline, MdTraffic, MdChecklist, MdAssessment, MdPerson, MdEvent, MdFeedback } from "react-icons/md";

const data = {
    id: 'data-group',
    type: 'group',
    roles: [1,100],
    breadcrumbs: false,
    children: [
      {
        id: 'data',
        title: "Data",
        type: 'collapse',
        icon: MdQueryStats,
        children: [
          {
            id: 'estadistica',
            title: "Estadística",
            type: 'collapse',
            breadcrumbs: false,
            icon: MdBarChart,
            children: [
              {
                id: 'estadistica-beneficiarios',
                title: "Beneficiarios",
                type: 'item',
                breadcrumbs: false,
                icon: MdPeople,
                url: '/data/estadistica/beneficiarios'
              },
              {
                id: 'estadistica-factores-riesgo',
                title: "Factores de Riesgo",
                type: 'item',
                breadcrumbs: false,
                icon: MdWarning,
                url: '/data/estadistica/factores-riesgo'
              },
              {
                id: 'estadistica-demografia',
                title: "Demografía",
                type: 'item',
                breadcrumbs: false,
                icon: MdAccessibility,
                url: '/data/estadistica/demografia'
              },
              {
                id: 'estadistica-seguimiento-post-evento',
                title: "Seguimiento",
                type: 'item',
                breadcrumbs: false,
                icon: MdTimeline,
                url: '/data/estadistica/seguimiento-post-evento'
              },
              {
                id: 'estadistica-eventos',
                title: "Eventos",
                type: 'item',
                breadcrumbs: false,
                icon: MdEvent,
                url: '/data/estadistica/eventos'
              },
              {
                id: 'estadistica-encuesta-salida',
                title: "Encuesta de Salida",
                type: 'item',
                breadcrumbs: false,
                icon: MdFeedback,
                url: '/data/estadistica/encuesta-salida'
              }
            ]
          },

          {
            id: 'data-reporte-evento',
            title: "Reporte de evento",
            type: 'item',
            breadcrumbs: false,
            icon: MdAssessment,
            url: '/data/reporte-evento'
          },
          {
            id: 'formularios',
            title: "Formularios",
            type: 'item',
            breadcrumbs: false,
            icon: MdPerson,
            url: '/data/formularios'
          }
        ]
      }
    ]
};

export default data;
